import { render } from "./SignUpPage.vue?vue&type=template&id=547117b3&scoped=true&ts=true"
import script from "./SignUpPage.vue?vue&type=script&lang=ts"
export * from "./SignUpPage.vue?vue&type=script&lang=ts"

import "./SignUpPage.vue?vue&type=style&index=0&id=547117b3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-547117b3"]])

export default __exports__